module.exports = __webpack_public_path__ + "static/img/logotipoNegro.65591724.png";